var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38327 0 0 5.38327 0 12C0 18.6167 5.38327 24 12 24C18.6167 24 24 18.6167 24 12C24 5.38327 18.6167 0 12 0ZM18.2452 7.97827L10.4913 17.209C10.4063 17.3103 10.3005 17.3922 10.181 17.449C10.0616 17.5059 9.9313 17.5364 9.79904 17.5385H9.78346C9.65408 17.5384 9.52615 17.5112 9.40798 17.4585C9.2898 17.4058 9.18402 17.3289 9.0975 17.2327L5.77442 13.5404C5.69003 13.4509 5.62438 13.3454 5.58133 13.2301C5.53828 13.1149 5.51871 12.9922 5.52375 12.8693C5.5288 12.7464 5.55836 12.6257 5.61071 12.5144C5.66306 12.403 5.73713 12.3033 5.82858 12.221C5.92003 12.1387 6.027 12.0755 6.14321 12.0352C6.25943 11.9948 6.38254 11.9781 6.50531 11.986C6.62808 11.9939 6.74803 12.0262 6.85811 12.0812C6.9682 12.1361 7.0662 12.2124 7.14635 12.3058L9.75923 15.2088L16.8317 6.79096C16.9904 6.60755 17.2148 6.49393 17.4566 6.47466C17.6983 6.4554 17.9379 6.53204 18.1236 6.68802C18.3093 6.844 18.4261 7.06678 18.4489 7.30822C18.4716 7.54966 18.3985 7.79035 18.2452 7.97827Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.d629d4535012fc570bc4b25a18945cf6.svg";
export { ForwardRef as ReactComponent };